/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Box, FormLabel, MenuItem } from '@mui/material';
import { TextV2, InputSelectV2 } from '@insights-ltd/design-library/components';
import { useTranslation } from 'react-i18next';
import { Dialects } from 'types/dialects';
import { DIALECT_MAP, ENABLED_WHEEL_DIALECTS } from 'variables';
import { spacingSizeMap } from '@insights-ltd/design-library/themes';
import { useWheelContext, WheelState } from './hooks/useWheelContext';

const SelectTypeControl = () => {
  const { t } = useTranslation();
  const [{ changeLanguage, languageType }, setState] = useWheelContext();

  const handleChange = (newValue: string) => {
    setState((prevState: WheelState) => ({
      ...prevState,
      fontSize: DIALECT_MAP.find(({ value }) => value === newValue)!
        .wheelFontSize,
      tableFontSize: DIALECT_MAP.find(({ value }) => value === newValue)!
        .tableFontSize,
      languageType: newValue as Dialects,
    }));
    changeLanguage(newValue);
  };

  return (
    <>
      <FormLabel component="legend">
        <TextV2 variant="h3">
          {t('ui.event-management.events.team-wheel.select-language')}
        </TextV2>
      </FormLabel>
      <Box sx={(theme) => ({ mb: theme.spacing(spacingSizeMap.M) })} />
      <InputSelectV2
        labelText=""
        id="language-select"
        value={languageType}
        onChange={(event) => handleChange(event.target.value as string)}
      >
        {ENABLED_WHEEL_DIALECTS.map(({ textKey, value }) => (
          <MenuItem key={value} value={value}>
            {t(textKey)}
          </MenuItem>
        ))}
      </InputSelectV2>
    </>
  );
};

export default SelectTypeControl;
/* eslint-enable @typescript-eslint/no-non-null-assertion */
